import { graphql } from "@/graphql/codegen/gql"

graphql(`
  mutation PutPalletOnHold($input: InventoryPalletHoldInput!) {
    inventory {
      putPalletOnHold(input: $input) {
        __typename
        ... on InventoryPalletHoldSuccess {
          pallet {
            referenceNbr
            isOnHold
          }
        }
        ... on InventoryPalletHoldFailure {
          error {
            title
            message
          }
        }
      }
    }
  }

  mutation ReleasePalletHold($input: InventoryPalletHoldInput!) {
    inventory {
      releasePalletHold(input: $input) {
        __typename
        ... on InventoryPalletHoldSuccess {
          pallet {
            referenceNbr
            isOnHold
          }
        }
        ... on InventoryPalletHoldFailure {
          error {
            title
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation ChangeLotQualityStatus($input: InventoryChangeQualityStatusInput!) {
    inventory {
      changeQualityStatus(input: $input) {
        __typename
        ... on InventoryChangeQualityStatusSuccess {
          productId
          lotNumber
          batchNumber
          pendingStatus
        }
        ... on InventoryChangeQualityStatusFailure {
          error {
            title
            message
          }
        }
      }
    }
  }
`)
